module.exports = __webpack_public_path__ + "img/paywave.46c53f8b.png";